import { FirebaseApp } from "firebase/app";
import { collection, getDocs, getFirestore, query } from "firebase/firestore";

export const getStreamingTitleWithLink = (
  streamingTitle: any,
  streamingUrl: any
) => {
  if (streamingTitle) {
    return `[[${streamingTitle}>${streamingUrl}]]`;
  }
  return "";
};

export const getFaceWithNameLink = (name: any) =>
  `&attachref(${name}/face.png,nolink,25x25);[[${name}]]`;

export type MemberInfo = {
  channel: string;
  name: string;
  namae: string;
};

export const getMembersFromFirestore = async (
  firebaseApp: FirebaseApp,
  setMemberList: React.Dispatch<React.SetStateAction<MemberInfo[]>>
) => {
  const members: Array<MemberInfo> = [];
  const db = getFirestore(firebaseApp);
  const q = query(collection(db, "members"));
  getDocs(q).then((querySnapshot) => {
    querySnapshot.forEach((doc) => {
      const d = doc.data();
      const mi: MemberInfo = {
        channel: d.channel,
        name: d.name,
        namae: d.namae,
      };
      members.push(mi);
    });
    members.sort((a, b) => a.namae.localeCompare(b.namae, "ja"));
    setMemberList(members);
  });
};
